<span v-if="svg" ref="iconContainer"></span>
